import { Tier1SleeveRow } from '../../types/tier1Portfolio';

export function cockpitWeightsMapFromTargets(
  sleeves: Array<{ key: string; target: number }>,
): Map<string, number> {
  return new Map(sleeves.map((s) => [s.key, s.target]));
}

export function mergeCockpitWeightsIntoSleeves(
  sleeves: Tier1SleeveRow[],
  cockpitBySleeveKey: Map<string, number>,
): Tier1SleeveRow[] {
  if (cockpitBySleeveKey.size === 0) return sleeves;
  return sleeves.map((s) => {
    const cockpitWeightPct = cockpitBySleeveKey.get(s.sleeveKey);
    return cockpitWeightPct != null ? { ...s, cockpitWeightPct } : s;
  });
}

export function neutralWeightsMapFromAllocation(
  sleeves: Array<{ key: string; neutral: number }>,
): Map<string, number> {
  return new Map(sleeves.map((s) => [s.key, s.neutral]));
}

export function mergeNeutralWeightsIntoSleeves(
  sleeves: Tier1SleeveRow[],
  neutralBySleeveKey: Map<string, number>,
): Tier1SleeveRow[] {
  if (neutralBySleeveKey.size === 0) return sleeves;
  return sleeves.map((s) => {
    const neutralWeightPct = neutralBySleeveKey.get(s.sleeveKey);
    return neutralWeightPct != null ? { ...s, neutralWeightPct } : s;
  });
}

/** Count sleeves where new plan target differs from cockpit by more than epsilon. */
export function countPlanDeviationsFromCockpit(
  sleeves: Tier1SleeveRow[],
  epsilon = 0.05,
): number {
  return sleeves.filter((s) => {
    if (s.cockpitWeightPct == null) return false;
    return Math.abs(s.policyWeightPct - s.cockpitWeightPct) > epsilon;
  }).length;
}
